/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Component } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import PropTypes from 'prop-types';
import DropDownComponent from '../../shared_components/buttons/DropDownComponent';
import CloseOutsideBorderComponent from '../../hocs/CloseOutsideBorderComponent';
import OverviewData from '../../../stores/OverviewStore';

class OverviewTableSelectColumnComponent extends Component {
  constructor(props) {
    super(props);

    this.setFixedRateTerm = this.setFixedRateTerm.bind(this);
  }

  setFixedRateTerm(param, e) {
    e.stopPropagation();

    if (this.props.order === 'first') {
      this.props.setFirstOverviewTableColumnFixedRateTerm(param);
    } else if (this.props.order === 'second') {
      this.props.setSecondOverviewTableColumnFixedRateTerm(param);
    }

    this.props.getNewLabelInterests(param);
    this.props.closeOpenSortingDropdown();
    this.props.sortLabelInterestsByTermInterest(param);
  }

  render() {
    const {
      setOpenSortingDropdown,
      fixedRateTerm,
      otherFixedRateTerm,
      classNames,
      openSortingDropdown,
      allFixedRateTerms,
      order,
    } = this.props;

    let dropDown = '';

    if (order === openSortingDropdown) {
      const fixedRateTerms = allFixedRateTerms.map((fixedRateTermItem) => {
        let listItem = '';

        if (fixedRateTermItem !== fixedRateTerm && fixedRateTermItem !== otherFixedRateTerm) {
          listItem = (
            <div
              onClick={(e) => {
                this.setFixedRateTerm(fixedRateTermItem, e);
              }}
              className={this.props.dropdownListItemClassName}
              key={fixedRateTermItem}
            >{fixedRateTermItem} jaar rentevast
            </div>
          );
        }

        return listItem;
      });

      dropDown = (
        <div className={this.props.dropdownListClassName}>
          {fixedRateTerms}
        </div>
      );
    }

    /* Set component */
    let component = null;

    /* Rotate select field arrow */
    const dropdownClassName = (order === openSortingDropdown) && 'overview-container__rotated-dropdown';

    /* Set default functionality */
    const defaultComponentPart = (
      <div>
        {fixedRateTerm} jaar rentevast
        <span className="float-right">
          <DropDownComponent className={`overview-container__dropdown ${dropdownClassName}`} />
        </span>
        <CSSTransitionGroup
          transitionName="slide-down"
          transitionEnterTimeout={100}
          transitionLeaveTimeout={1}
        >
          {dropDown}
        </CSSTransitionGroup>
      </div>
    );


    if (this.props.partOfTable) {
      component = (
        <th onClick={() => { setOpenSortingDropdown(order); }} colSpan={2} >
          {defaultComponentPart}
        </th>
      );
    } else {
      component = (
        <div onClick={() => { setOpenSortingDropdown(order); }} className={this.props.classNames} >
          {defaultComponentPart}
        </div>
      );
    }

    return component;
  }
}

OverviewTableSelectColumnComponent.propTypes = {
  partOfTable: PropTypes.bool,
  setOpenSortingDropdown: PropTypes.func,
  setFirstOverviewTableColumnFixedRateTerm: PropTypes.func,
  setSecondOverviewTableColumnFixedRateTerm: PropTypes.func,
  sortLabelInterestsByTermInterest: PropTypes.func,
  closeOpenSortingDropdown: PropTypes.func,
  getNewLabelInterests: PropTypes.func,
  allFixedRateTerms: PropTypes.arrayOf(PropTypes.number),
  fixedRateTerm: PropTypes.number,
  otherFixedRateTerm: PropTypes.number,
  classNames: PropTypes.string,
  openSortingDropdown: PropTypes.string,
  dropdownListItemClassName: PropTypes.string,
  dropdownListClassName: PropTypes.string,
  order: PropTypes.string,
};

OverviewTableSelectColumnComponent.defaultProps = {
  partOfTable: true,
  setFirstOverviewTableColumnFixedRateTerm: () => {},
  setSecondOverviewTableColumnFixedRateTerm: () => {},
  sortLabelInterestsByTermInterest: () => {},
  closeOpenSortingDropdown: () => {},
  setOpenSortingDropdown: () => {},
  getNewLabelInterests: () => {},
  allFixedRateTerms: [],
  fixedRateTerm: '',
  otherFixedRateTerm: '',
  classNames: '',
  openSortingDropdown: '',
  dropdownListItemClassName: '',
  dropdownListClassName: '',
  order: '',
};

export default CloseOutsideBorderComponent(
  OverviewTableSelectColumnComponent,
  OverviewData.closeOpenSortingDropdown,
  '.overview-container__sort-column-list');
